module.exports = __webpack_public_path__ + "static/media/bg31.e6ce07c5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/dummy-images/bg31.jpeg
// module id = ./src/CSS/assets-minified/dummy-images/bg31.jpeg
// module chunks = 0